import React, { useEffect, useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";

const ExportData = ({}) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.appraisal);

  return (
    <GlobalDialog
      title={"Export Data"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          variant="outlined"
          color="primary"
          disabled
          onClick={() => setOpen(true)}
        >
          <Icon icon="mdi:file-export" width={18} height={18} />
          Export
        </Button>
      }
      content={<></>}
    />
  );
};

export default ExportData;
